import { render } from "./ImageEllipseOutline.vue?vue&type=template&id=afb83d1c&scoped=true&ts=true"
import script from "./ImageEllipseOutline.vue?vue&type=script&lang=ts"
export * from "./ImageEllipseOutline.vue?vue&type=script&lang=ts"

import "./ImageEllipseOutline.vue?vue&type=style&index=0&id=afb83d1c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb83d1c"]])

export default __exports__